import * as stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex.ts';
import { fonts } from '@shared/tokens/fonts.stylex.ts';
import { anatomy } from '@shared/tokens/anatomy.stylex.ts';

export const styles = stylex.create({
  popover: {
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
  },
  popoverLeft: {
    flexDirection: 'row',
  },
  popoverTop: {
    flexDirection: 'column',
  },
  popoverTopDisabled: {
    flexDirection: 'column',
    marginTop: '12px',
  },
  popoverRight: {
    flexDirection: 'row-reverse',
  },
  popoverBottom: {
    flexDirection: 'column-reverse',
  },
  popoverTopLeft: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: anatomy['space-4'],
    marginLeft: '-6px',
    ':not(#__unused__) > svg': {
      marginLeft: anatomy['space-8'],
      overflow: 'visible',
    },
  },
  popoverTopRight: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginLeft: anatomy['space-10'],
    ':not(#__unused__) > svg': {
      marginRight: anatomy['space-10'],
      overflow: 'visible',
    },
  },
  popoverBottomLeft: {
    flexDirection: 'column-reverse',
    alignItems: 'flex-start',
  },
  popoverBottomRight: {
    flexDirection: 'column-reverse',
    alignItems: 'flex-end',
  },
  title: {
    color: colors.primaryInverseText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-5'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeBody-5'],
    whiteSpace: 'pre-line',
    userSelect: 'none',
  },
  titleDisabled: {
    color: colors.primaryInverseText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
    whiteSpace: 'pre-line',
    userSelect: 'none',
    width: '245px',
  },
  message: {
    position: 'relative',
    backgroundColor: colors.primaryInverseBackground,
    padding: '12px',
    borderRadius: anatomy.borderRadiusS,
  },
  messageDisabled: {
    position: 'relative',
    backgroundColor: colors.primaryInverseBackground,
    padding: '8px',
    borderRadius: anatomy.borderRadiusXs,
  },
  shadow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    boxShadow: '0 0 20px 0 #2c30320d',
    borderRadius: anatomy.borderRadiusS,
  },
  arrow: {
    fill: colors.primaryInverseBackground,
  },
  popoverLight: {
    background: 'green',
    ':not(#__unused__) > div': {
      background: `${colors.primaryBackground} !important`,
    },
    ':not(#__unused__) > svg': {
      fill: `${colors.primaryBackground} !important`,
    },
    ':not(#__unused__) > div > div': {
      color: `${colors.primaryText} !important`,
    },
  },
});
